import { type RefObject, useEffect, useState } from 'react';

const INTERSECTION_THRESHOLD = 0.3;

export type SpiderWebIntersectionVisibility = {
	isVisible: boolean;
	isCurrentlyVisible: boolean;
};

export function useSpiderWebIntersectionVisibility(
	containerRef: RefObject<HTMLDivElement | null>,
	replayOnVisible: boolean,
): SpiderWebIntersectionVisibility {
	const [hasBeenVisible, setHasBeenVisible] = useState(false);
	const [isCurrentlyVisible, setIsCurrentlyVisible] = useState(false);

	useEffect(() => {
		const el = containerRef.current;
		if (!el) {
			return;
		}

		const observer = new IntersectionObserver(
			([entry]: IntersectionObserverEntry[]) => {
				if (!entry) {
					return;
				}
				setIsCurrentlyVisible(entry.isIntersecting);
				if (entry.isIntersecting) {
					setHasBeenVisible(true);
				}
			},
			{
				threshold: INTERSECTION_THRESHOLD,
			},
		);
		observer.observe(el);
		return () => observer.disconnect();
	}, [containerRef]);

	return {
		isVisible: replayOnVisible ? isCurrentlyVisible : hasBeenVisible,
		isCurrentlyVisible,
	};
}
